import { Instance, flow, types } from 'mobx-state-tree';

import {
	type ILoginData,
	type IRegisterData,
	type IResetPasswordData,
	type IResetPasswordTokenData,
	login,
	register,
} from '@common/api/auth';

import AuthInterface from './AuthInterface';

export { ILoginData, IRegisterData, IResetPasswordData, IResetPasswordTokenData };

const AuthModel = AuthInterface.named('AuthModel')
	.props({
		authLoading: types.optional(types.boolean, false),
	})
	.actions((self) => ({
		login: flow(function* (data: ILoginData, isSave: boolean = false) {
			self.loading = true;
			self.authLoading = true;
			try {
				const result = yield login(data);
				yield self._login(result, isSave);
			} finally {
				self.loading = false;
				self.authLoading = false;
			}
		}),
		register: flow(function* (data: IRegisterData) {
			self.loading = true;
			self.authLoading = true;
			try {
				const result = yield register(data);
				if (result.token) {
					yield self._login(result);
				} else {
					return result;
				}
			} finally {
				self.loading = false;
				self.authLoading = false;
			}
		}),
	}));

export default AuthModel;

export interface IAuthModel extends Instance<typeof AuthModel> {}
